import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import firebase from 'firebase';
import { reactReduxFirebase } from 'react-redux-firebase';
import rootReducer from './reducers';
import { fbConfig } from './config';

firebase.initializeApp(fbConfig);
// react-redux-firebase options
const config = {
  userProfile: 'users', // firebase root where user profiles are stored
  enableLogging: false // enable/disable Firebase's database logging
};

export const history = createHistory();

const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

// Add redux Firebase to compose
const createStoreWithFirebase = compose(reactReduxFirebase(firebase, config))(
  createStore
);

export default createStoreWithFirebase(
  rootReducer,
  initialState,
  composedEnhancers
);
// createStore(rootReducer, initialState, composedEnhancers);



// WEBPACK FOOTER //
// ./src/store.js